import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { addWarningNotification } from '@application/features/common/notificationSlice';
import { useAppDispatch } from '@application/store/useStore';
import { IonIcon } from '@ionic/react';
import VnButton from '@ui/components/VnButton';
import { cloudUploadOutline, documentOutline } from 'ionicons/icons';
import { useState } from 'react';
import { FileUploader } from 'react-drag-drop-files';
import '@ui/styles/attachments-style.css';
import { addAttachmentByDocumentationIdAsync } from '@application/features/documentation/documentationThunk';
import { Controller, useForm } from 'react-hook-form';
import VnValidation from '@ui/components/VnValidation';
import { useParams } from 'react-router-dom';
const AddAttachmentForm = ({ onClose, onDocumentationDocumentGridUpdate }) => {
    const [documentationFile, setDocumentationFile] = useState('');
    const documentationFileLimit = 2 * 1024 * 1024;
    const dispatch = useAppDispatch();
    const { id } = useParams();
    const [droppStyling, setDroppStyling] = useState({
        backgroundColor: '#EBF7FD',
        border: 'none',
        paddingRight: '700px',
        postion: 'relative',
        left: '-30px',
        top: '-15px',
        right: ''
    });
    const { setValue, handleSubmit, register, watch, control, setError, clearErrors, formState: { errors } } = useForm({
        defaultValues: {
            documentationId: parseInt(id)
        }
    });
    const uploadFile = (data) => {
        if (documentationFile) {
            if (documentationFile.size <= documentationFileLimit) {
                if (![
                    'image/jpeg',
                    'image/png',
                    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                    'application/vnd.ms-excel',
                    'application/pdf',
                    'text/csv'
                ].includes(documentationFile.type)) {
                    dispatch(addWarningNotification('Alleen jpeg, jpg, png, pdf, csv, xls en xlsx bestanden zijn toegestaan'));
                }
                else {
                    dispatch(addAttachmentByDocumentationIdAsync({ ...data, document: documentationFile }))
                        .unwrap()
                        .then((res) => {
                        onDocumentationDocumentGridUpdate();
                        onClose();
                        setDocumentationFile('');
                    });
                }
            }
        }
    };
    const FileUploaderDesign = (_jsxs("div", { className: 'container Vn-fileuploader-container-styling', children: [_jsxs("div", { className: 'Vn-fileUploader-styling mt-4', children: [_jsx(IonIcon, { icon: cloudUploadOutline, className: 'Vn-custom-icon' }), _jsx("div", { children: _jsx("p", { children: "Klik of sleep een bestand naar dit gebied om te uploaden." }) }), _jsx("div", { children: _jsx("p", { children: "Maximale bestandsgrootte 2MB." }) })] }), _jsx("div", { className: 'Vn-fileUploaded-styling mt-3', children: _jsx("div", { className: documentationFile && documentationFile.size <= documentationFileLimit ? '' : 'vn-input-field-error', children: documentationFile ? (documentationFile.size <= documentationFileLimit ? (_jsxs("div", { className: 'd-flex', children: [_jsx("div", { className: 'Vn-settings-custom-icon', children: _jsx(IonIcon, { icon: documentOutline }) }), _jsxs("div", { children: [" ", documentationFile.name] })] })) : ('Bestandsgrootte overschrijdt de limiet van 2 MB.')) : (errors.document && _jsx("span", { className: 'vn-input-field-error', children: errors.document.message })) }) })] }));
    return (_jsxs(_Fragment, { children: [_jsx("div", { className: 'row mt-4 mb-3', children: _jsxs("div", { className: 'form-group col-md-6', children: [_jsxs("label", { className: 'form-label vn-text-label', children: ["Titel", _jsx("span", { className: 'vn-AsterikMark', children: "*" })] }), _jsx("input", { id: 'name', type: 'text', placeholder: 'Voer titel in', className: 'form-control vn-Input', ...register('title', {
                                required: 'Dit veld is verplicht'
                            }) }), _jsx(VnValidation, { fieldError: errors.title })] }) }), _jsx("div", { className: 'row mt-2', children: _jsx("div", { className: 'col-md-12', children: _jsx(Controller, { name: 'document', control: control, rules: { required: 'Dit veld is verplicht' }, render: ({ field: { onChange, value } }) => (_jsx(FileUploader, { children: FileUploaderDesign, multiple: false, name: 'file', handleChange: (value) => {
                                onChange(value);
                                setDocumentationFile(value);
                            }, dropMessageStyle: droppStyling, classes: 'vn-fileupload-wrapper', hoverTitle: ' ' })) }) }) }), _jsx("div", { className: 'vn-Form_Footer mt-4', children: _jsxs("div", { style: { display: 'flex', marginLeft: 'auto' }, children: [_jsx(VnButton, { customClassName: 'Vn-cancel-button', mode: 'secondary', type: 'button', onClick: onClose, children: "Annuleren" }), _jsx(VnButton, { customClassName: 'Vn-save-button vn-popup-save-button', mode: 'primary', type: 'button', onClick: handleSubmit(uploadFile), children: "Opslaan" })] }) })] }));
};
export default AddAttachmentForm;
